<template>
    <div class="m-accordion__box">
        <div class="m-accordion__header"
             :class="{ 'm-accordion__box--closed': !isOpen,
                        'm-accordion__box--closed--has-error': hasError && !isOpen,
                        'm-accordion__box--open': isOpen && showOpen}"
             @click="triggerOpenNext(index)">
            <slot name="header"></slot>
            <span :class="['accordion-header-icon',{'accordion-header-icon-open':isOpen , 'accordion-header-icon-closed':!isOpen}]"></span>
        </div>
        <div class="m-accordion__item-content" :class="{'m-accordion__item-content--pull' : contentPull}"
             v-show="isOpen">
            <slot></slot>
            <slot name="if-slot" v-if="isOpen"></slot>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'accordion-item',
        props: {
            hasError: {
                type: Boolean,
                default: false
            },
            keepClosed: {
                type: Boolean,
                default: false
            },
            contentPull: {
                type: Boolean,
                default: false
            },
            showOpen: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('accordion', {
                findIsOpen: 'isOpen'
            }),
            isOpen() {
                return this.findIsOpen(this.index);
            }
        },
        data() {
            return {
                index: null
            }
        },
        methods: {
            ...mapActions('accordion', [
                'setOpen',
                'openNext'
            ]),
            triggerOpenNext() {
                if (this.showOpen && this.isOpen) {
                    return this.openNext(this.index);
                }
                if (!this.isOpen) {
                    return this.setOpen(this.index);
                }
            }
        },
        created() {
            this.$store.dispatch('accordion/register', this.keepClosed).then(index => {
                this.index = index;
            });
        },
        destroyed() {
            return this.$store.dispatch('accordion/deregister', this.index);
        }
    }
</script>


// WEBPACK FOOTER //
// AccordionItem.vue?b6d68e32